var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_34597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15V12.75H10.5V11.25H12.75V9H14.25V11.25H16.5V12.75H14.25V15H12.75ZM8.25 12.75H5.25C4.2125 12.75 3.32812 12.3844 2.59687 11.6531C1.86562 10.9219 1.5 10.0375 1.5 9C1.5 7.9625 1.86562 7.07812 2.59687 6.34687C3.32812 5.61562 4.2125 5.25 5.25 5.25H8.25V6.75H5.25C4.625 6.75 4.09375 6.96875 3.65625 7.40625C3.21875 7.84375 3 8.375 3 9C3 9.625 3.21875 10.1562 3.65625 10.5938C4.09375 11.0312 4.625 11.25 5.25 11.25H8.25V12.75ZM6 9.75V8.25H12V9.75H6ZM16.5 9H15C15 8.375 14.7812 7.84375 14.3438 7.40625C13.9062 6.96875 13.375 6.75 12.75 6.75H9.75V5.25H12.75C13.7875 5.25 14.6719 5.61562 15.4031 6.34687C16.1344 7.07812 16.5 7.9625 16.5 9Z",
    fill: "#1C1B1F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.17fce0abdc694ba9e174219659edc1a6.svg";
export { ForwardRef as ReactComponent };